import * as React           from 'react';
import Container            from '@mui/material/Container';
import Box                  from '@mui/material/Box';
import Typography           from '@mui/material/Typography';
//import Avatar               from '@mui/material/Avatar';
import { useQuery }         from 'react-query';
import StudentsTable        from 'ui/components/students-components/StudentsTable';
//import SyncButton           from 'ui/components/students-components/SyncButton';
import Copyright            from 'ui/components/Copyright';
import { HttpClient }       from 'apiclient/ApiClient';
import ITeacher             from 'models/ITeacher';
import {
    STUDENTS_TABLE_HEADER,
    //SYNC_INFO_SYNCED,
    //SYNC_INFO_NOT_SYNCED
}                           from 'config/config';
//import CHECK                from 'icons/check.png';
//import ATTENTION            from 'icons/attention.png';

const Students = ({classId, source}: {classId?: string, source?: string}) => {
    const [ syncState, setSyncState ] = React.useState(true);
    //const [ studentsPresent, setStudentsPresent ] = React.useState(false);
    const [ , setIsAddStudentVisible ] = React.useState(true);
    const httpClient = HttpClient();
    useQuery('teacher',
        async () => await httpClient.get('teacher'),
        {
            onSuccess: async (data: ITeacher) => {
                if (data.is_synced !== syncState) {
                    setSyncState(data.is_synced);
                }
            }
        }
    );
    return(
        <>
            <Container maxWidth='lg' sx={{pb: 6, pt: 6}}>
                <Box sx={{
                    display: 'flex',
                    alignItems: 'baseline',
                    justifyContent: "space-between",
                    mb: 1,
                    mt: 12
                }}>
                    <Typography variant="h6" flexShrink={0} marginRight={4} >{STUDENTS_TABLE_HEADER}</Typography>
                    {/*
                        syncState && studentsPresent ?
                        (
                            <Box display='flex' flexDirection='row' alignItems='baseline'>
                                <Avatar src={CHECK} sx={{width: 26, height: 'auto', mr: 1, top: 5}}/>
                                <Typography color="success.main">{SYNC_INFO_SYNCED}</Typography>
                            </Box>
                        )
                        :(!syncState && (
                            <Box display='flex' flexDirection='row' alignItems='baseline'>
                                <Avatar src={ATTENTION} sx={{width: 26, height: 'auto', mr: 1, top: 5}}/>
                                <Typography color="error">{SYNC_INFO_NOT_SYNCED}</Typography>
                            </Box>
                        ))
                    */}
                </Box>
                <StudentsTable
                    setSyncState={setSyncState}
                    //setStudentsPresent={setStudentsPresent}
                    setIsAddStudentVisible={setIsAddStudentVisible}
                    classId={classId}
                    source={source}
                />
                {/*
                    (studentsPresent || !syncState) &&
                    <SyncButton syncState={syncState} setSyncState={setSyncState} />
                */}
                <Copyright sx={{mt: 10}}/>
            </Container>
        </>
    );
};

export default Students;